var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1),_c('audio',{attrs:{"id":"chatAudio"}}),(_vm.showTam)?_c('el-collapse-transition',[_c('div',{staticClass:"tianmen",on:{"click":_vm.hoverClear}},[_c('img',{attrs:{"src":"/images/public/pnewyear.png"}})])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }